import React, { useState, useEffect, useContext, Fragment } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import useLatLng from "hooks/uselatlng/uselatlng";
import DocumentView from 'components/sales/downloadDocView/documentView';

const NcsMeetingComplete = ({
    getNcsMeetingbyId,
    ncsMeetingsData,
    match,
}) => {

  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [ncsData, setNcsData] = useState(null);
  const islatlng = useLatLng();

  useEffect(() => {
    if (getNcsMeetingbyId !== null){
        (async () => {
            setIsLoading(true);
            const res = await getNcsMeetingbyId(match.params.id,"Completed");
            if(res) {
              console.log(res);
            }
            setIsLoading(false);
          })();
    }
      
  }, [getNcsMeetingbyId]); 

  useEffect(() => {
    if (ncsMeetingsData && ncsMeetingsData && ncsMeetingsData?.length > 0) {
      setNcsData(ncsMeetingsData[0]); 
    }
  }, [ncsMeetingsData]);


console.log('dd ' + JSON.stringify(ncsData?.meeting_meta_data?.attachments));
return (
  <Layout
    title={localization.ncsMeetingDetails}
    isGoback
    isLoading={isLoading}
  >
  <div className="container-fluid">
    <CardSection title={localization.ncsScheduledAgainstSite}>
            {(ncsData?.meeting_meta_data && ncsData?.meeting_meta_data != null) && 
            <>
            <div className="details-listing">
              <DivLayout
                    heading={'Site Number'}
                    data={ncsData && ncsData?.site_number}
              />
              <DivLayout
                  heading={'Project Name'}
                  data={ncsData && ncsData?.lead_site_client_name}
              />
              <DivLayout
                  heading={'Project Address'}
                  data={ncsData && ncsData?.lead_site_address_1}
              />
              </div>
              </>
              }
      </CardSection>
      <CardSection title={localization.checkinAndCheckoutDetails}>
           <>
            <div className="details-listing">
              <DivLayout
                    heading={'Checkin Date & Time'}
                    data={ncsData && ncsData?.check_in_date_time}
              />
              <DivLayout
                  heading={'Checkout Date & Time'}
                  data={ncsData && ncsData?.check_out_date_time}
              />
              </div>
              <div className="details-listing">
                <div>
                  {(ncsData && ncsData?.check_in_selfie != null) && 
                    <div><DocumentView title="Checkin Selfie" attachment={ncsData?.check_in_selfie} /></div>
                  }
                  {(ncsData && ncsData?.check_out_selfie != null) && 
                    <div><DocumentView title="Checkout Selfie" attachment={ncsData?.check_out_selfie} /></div>
                  }
                </div>
              </div>
            </>
      </CardSection>
      <CardSection title={localization.ncsMeetingDetailsView}>
            {ncsData?.meeting_meta_data && ncsData?.meeting_meta_data != null ? 
            <>
            <div className="details-listing">
              <DivLayout
                  heading={'Account Id'}
                  data={ncsData && ncsData?.account_id}
              />
              <DivLayout
                    heading={'Account Name'}
                    data={ncsData && ncsData?.meeting_meta_data?.account_name}
              />
              <DivLayout
                  heading={'Account Address'}
                  data={ncsData && ncsData?.meeting_meta_data?.account_address}
              />
              <DivLayout
                  heading={'Last Activity'}
                  data={ncsData && ncsData?.meeting_meta_data?.last_activity_date}
              />
              <DivLayout
                  heading={'No. Of Gates'}
                  data={ncsData && ncsData?.meeting_meta_data?.no_of_gates}
              />
              <DivLayout
                    heading={'Boom Barrier Present'}
                    data={ncsData && ncsData?.meeting_meta_data?.boom_barrier_present}
                />
              <DivLayout
                  heading={'Competitor Name'}
                  data={ncsData && ncsData?.meeting_meta_data?.competitor_name}
              />
              <DivLayout
                  heading={'Competitor Solution'}
                  data={ncsData && ncsData?.meeting_meta_data?.competitor_solution}
              />
              <DivLayout
                  heading={'Existing Problem Faced'}
                  data={ncsData && ncsData?.meeting_meta_data?.exisiting_problem_faced}
              />
              <DivLayout
                  heading={'Completed At'}
                  data={ncsData && ncsData?.updated_at}
              />
              {ncsData?.meeting_meta_data?.attachments && 
                ncsData?.meeting_meta_data?.attachments.map((v,i) => {
                  console.log('i >> ', v.url);
                  return (
                    <>
                     {v.url != "" && <div className='col-md-6'><DocumentView attachment={v.url} /></div>}
                    </>
                  )
                })
              }
            </div>
            </>
            : <div class="mb-3 red text-cetnter">No information captured on this meeting</div>}
      </CardSection>
    </div>
  </Layout>
);
};

export default NcsMeetingComplete;
